import { useQueryWithUserId } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This is to track the filter categories from the backend.
 */
const INVENTORY_FILTER_LIST_KEY = 'inventory-filter-list-query';

/**
 * This hook fetches list of inbound filter items from mock APi.
 */
export const useFetchInventoryFilterQuery = () => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [INVENTORY_FILTER_LIST_KEY],
    networkMode: 'always',
    queryFn: INBOUND_API.fetchInventoryFilterListOptions,
  });

  return {
    error,
    isError,
    data,
    isPending,
    refetchFilterListOptions: refetch,
  };
};
